import { faXmark } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Image, Modal } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { ImagePreviewActionButton } from '../ImagePreviewActionButton';
import classes from './ImagePreviewModal.module.css';

export interface ImagePreviewModalProps {
  alt?: string;
  onClose: VoidFunction;
  opened: boolean;
  src?: string;
}

export function ImagePreviewModal({ alt, onClose, opened, src }: ImagePreviewModalProps) {
  const { t } = useTranslation(['translation', 'page-planner']);

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      centered={true}
      withCloseButton={false}
      overlayProps={{ opacity: 0.7, blur: 3 }}
      padding={0}
      size="auto"
      classNames={{ content: classes.content }}
    >
      <ImagePreviewActionButton ariaLabel={t('close')} onClick={onClose}>
        <FontAwesomeIcon icon={faXmark} size="sm" />
      </ImagePreviewActionButton>
      <Image src={src} alt={alt || t('preview')} fit="contain" className={classes.image} />
    </Modal>
  );
}
